import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=7f55c9ed&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f55c9ed')) {
      api.createRecord('7f55c9ed', component.options)
    } else {
      api.reload('7f55c9ed', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=7f55c9ed&", function () {
      api.rerender('7f55c9ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8AcmlQw3fHX0p/JS/pricehelp.vue"
export default component.exports